import React from 'react';
import classes from './RenderSlateElement.module.scss';
import { EditableProps } from 'slate-react/dist/components/editable';
import { SlateLink } from '../SlateLink';
import { SlateMention } from '../SlateMention';

export const RenderSlateElementView: EditableProps['renderElement'] = (props): JSX.Element => {
  switch (props.element.type) {
    case 'mention': {
      const { element, attributes, children } = props;
      return <SlateMention {...{ element, attributes }}>{children}</SlateMention>;
    }
    case 'link': {
      const { element, attributes, children } = props;
      return <SlateLink {...{ element, attributes }}>{children}</SlateLink>;
    }
    default:
      return (
        <p {...props.attributes} className={classes.Paragraph}>
          {props.children}
        </p>
      );
  }
};
